import BlackFridayBanner from './components/BlackFridayBanner';
import ColectaLoggiBanner from './components/ColectaLoggiBanner';
import CyberMondayBanner from './components/CyberMondayBanner';
import CyberMondayRateBanner from './components/CyberMondayRateBanner';

function Banners() {
  return (
    <>
      <CyberMondayBanner />
      <BlackFridayBanner />
      <ColectaLoggiBanner />
      <CyberMondayRateBanner />
    </>
  );
}

export default Banners;
